module.exports = __webpack_public_path__ + "6877de1cbfa075d2ac74e2f49d9f1f4f.pdf";